const noop = () => {};

if (process.env.NODE_ENV === "production" && typeof window !== "undefined") {
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
  console.error = noop;
}
